<template><!-- svgo-optimised -->
<svg class="icon icon__copy" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<g clip-path="url(#clip0_5706_50332)">
<path d="M13.73 3.75H6.65C6.15294 3.75 5.75 4.15294 5.75 4.65V16.04C5.75 16.5371 6.15294 16.94 6.65 16.94H13.73C14.2271 16.94 14.63 16.5371 14.63 16.04V4.65C14.63 4.15294 14.2271 3.75 13.73 3.75Z" stroke="#333333" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M14.6301 6.57007H16.5501C17.0501 6.57007 17.4501 6.97007 17.4501 7.47007V18.8501C17.4501 19.3501 17.0501 19.7501 16.5501 19.7501H9.48008C8.98008 19.7501 8.58008 19.3501 8.58008 18.8501V16.9301" stroke="#333333" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
</g>
<defs>
<clipPath id="clip0_5706_50332">
<rect width="13.2" height="17.51" fill="white" transform="translate(5 3)"/>
</clipPath>
</defs>
</svg>
</template>